import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex h-12 w-full items-center justify-between px-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_3 = { class: "space-x-2" }
const _hoisted_4 = { class: "h-full-3rem flex w-full" }
const _hoisted_5 = { class: "h-[calc(100vh_-_7rem)] w-[350px]" }
const _hoisted_6 = {
  key: 0,
  class: "h-[calc(100vh_-_7rem)] w-[300px] pb-2"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "h-{calc(100vh-72px-3rem)} w-full" }, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "map",
    class: "relative h-full w-full"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_generic_packet = _resolveComponent("generic-packet")!
  const _component_date_picker_modal = _resolveComponent("date-picker-modal")!
  const _component_zone_create_modal = _resolveComponent("zone-create-modal")!
  const _component_delete_modal = _resolveComponent("delete-modal")!
  const _component_floorplan_create_modal = _resolveComponent("floorplan-create-modal")!
  const _component_tag_create_modal = _resolveComponent("tag-create-modal")!
  const _component_map_loader = _resolveComponent("map-loader")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_dropdown_button = _resolveComponent("dropdown-button")!
  const _component_devices_map = _resolveComponent("devices-map")!
  const _component_zones_map = _resolveComponent("zones-map")!
  const _component_floorplan_map = _resolveComponent("floorplan-map")!
  const _component_tags_map = _resolveComponent("tags-map")!
  const _component_main_section = _resolveComponent("main-section")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isGenericPacketModalOpened)
      ? (_openBlock(), _createBlock(_component_generic_packet, {
          key: 0,
          "device-uuid": _ctx.genericPacketUuid,
          onCloseModal: _ctx.closeGenericPacketModal
        }, null, 8, ["device-uuid", "onCloseModal"]))
      : _createCommentVNode("", true),
    (_ctx.isShowRouteModalOpened)
      ? (_openBlock(), _createBlock(_component_date_picker_modal, {
          key: 1,
          "is-show-route-modal-opened": _ctx.isShowRouteModalOpened,
          onShowAssetRoute: _ctx.showAssetRoute,
          onToggleModal: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isShowRouteModalOpened = false))
        }, null, 8, ["is-show-route-modal-opened", "onShowAssetRoute"]))
      : _createCommentVNode("", true),
    (_ctx.zoneService.isZoneFinishedDrawing)
      ? (_openBlock(), _createBlock(_component_zone_create_modal, {
          key: 2,
          "is-zone-create-modal-opened": _ctx.zoneService.isZoneFinishedDrawing,
          "refresh-data": _ctx.getZones,
          "wkt-coordinates": _ctx.zoneService.createdZoneWktCoordinates,
          onToggleModal: _ctx.cancelZoneCreate
        }, null, 8, ["is-zone-create-modal-opened", "refresh-data", "wkt-coordinates", "onToggleModal"]))
      : _createCommentVNode("", true),
    _createVNode(_component_delete_modal, {
      "is-deleting": _ctx.isZoneDeleteModalOpened,
      onCancelDelete: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isZoneDeleteModalOpened = false)),
      onToggleModal: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isZoneDeleteModalOpened = false)),
      onConfirmDelete: _ctx.deleteZone
    }, null, 8, ["is-deleting", "onConfirmDelete"]),
    (_ctx.isFloorplanCreateModalOpened)
      ? (_openBlock(), _createBlock(_component_floorplan_create_modal, {
          key: 3,
          "floorplan-service": _ctx.floorplanService,
          "is-floor-plan-create-modal-opened": _ctx.isFloorplanCreateModalOpened,
          onToggleModal: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isFloorplanCreateModalOpened = false)),
          onChangeToCreateMode: _ctx.changeFloorplanToCreateMode
        }, null, 8, ["floorplan-service", "is-floor-plan-create-modal-opened", "onChangeToCreateMode"]))
      : _createCommentVNode("", true),
    _createVNode(_component_delete_modal, {
      "is-deleting": _ctx.isFloorplanDeleteModalOpened,
      onCancelDelete: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isFloorplanDeleteModalOpened = false)),
      onToggleModal: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isFloorplanDeleteModalOpened = false)),
      onConfirmDelete: _ctx.deleteFloorplan
    }, null, 8, ["is-deleting", "onConfirmDelete"]),
    (_ctx.isTagCreateModalOpened)
      ? (_openBlock(), _createBlock(_component_tag_create_modal, {
          key: 4,
          "is-tag-create-modal-opened": _ctx.isTagCreateModalOpened,
          onToggleModal: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isTagCreateModalOpened = false)),
          onChangeToCreateMode: _ctx.changeTagToCreateMode,
          onAddTag: _ctx.addNewTagToMap
        }, null, 8, ["is-tag-create-modal-opened", "onChangeToCreateMode", "onAddTag"]))
      : _createCommentVNode("", true),
    _createVNode(_component_delete_modal, {
      "is-deleting": _ctx.isTagDeleteModalOpened,
      onCancelDelete: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isTagDeleteModalOpened = false)),
      onToggleModal: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isTagDeleteModalOpened = false)),
      onConfirmDelete: _ctx.deleteTag
    }, null, 8, ["is-deleting", "onConfirmDelete"]),
    _createVNode(_component_main_section, { "is-map": true }, {
      default: _withCtx(() => [
        (_ctx.isLoading || _ctx.routeIsLoading)
          ? (_openBlock(), _createBlock(_component_map_loader, { key: 0 }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_select, {
              modelValue: _ctx.floorStore.selectedFloor,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.floorStore.selectedFloor) = $event)),
              getOptionLabel: (label) => `Floor ${label}`,
              options: _ctx.floorStore.floors,
              class: "w-[150px]"
            }, null, 8, ["modelValue", "getOptionLabel", "options"])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_dropdown_button, {
              icon: ['fac', 'user-device'],
              name: 'Assets',
              "is-dropdown-opened": _ctx.showDevicesDatagrid,
              onToggleDatagrid: _ctx.toggleDevicesDatagrid
            }, null, 8, ["is-dropdown-opened", "onToggleDatagrid"]),
            (_ctx.showDevicesDatagrid)
              ? (_openBlock(), _createBlock(_component_devices_map, {
                  key: 0,
                  devices: _ctx.devices,
                  "web-socket-data": _ctx.webSocketData,
                  "get-selected-row": _ctx.getSelectedDeviceRow,
                  "show-asset-route-date-picker-modal": _ctx.toggleDatePickerModal,
                  "open-generic-packet-modal": _ctx.openGenericPacketModal
                }, null, 8, ["devices", "web-socket-data", "get-selected-row", "show-asset-route-date-picker-modal", "open-generic-packet-modal"]))
              : _createCommentVNode("", true),
            _createVNode(_component_dropdown_button, {
              icon: ['fas', 'draw-polygon'],
              name: 'Zones',
              "is-dropdown-opened": _ctx.showZonesDatagrid,
              onToggleDatagrid: _ctx.toggleZonesDatagrid
            }, null, 8, ["is-dropdown-opened", "onToggleDatagrid"]),
            (_ctx.showZonesDatagrid)
              ? (_openBlock(), _createBlock(_component_zones_map, {
                  key: 1,
                  zones: _ctx.zones,
                  "get-selected-row": _ctx.getSelectedZoneRow,
                  "is-zone-create-mode": _ctx.isZoneCreateMode,
                  "is-zone-edit-mode": _ctx.isZoneEditMode,
                  onSaveEditedZone: _ctx.saveEditedZone,
                  onToggleCreateZoneModal: _ctx.toggleCreateZoneModal,
                  onToggleZoneEdit: _ctx.toggleZoneEdit,
                  onToggleDeleteModal: _ctx.toggleZoneDeleteModal,
                  onCancelZoneEdit: _ctx.cancelZoneEdit,
                  onCancelZoneCreate: _ctx.cancelZoneCreate,
                  onToggleTagActions: _ctx.toggleTagActions
                }, null, 8, ["zones", "get-selected-row", "is-zone-create-mode", "is-zone-edit-mode", "onSaveEditedZone", "onToggleCreateZoneModal", "onToggleZoneEdit", "onToggleDeleteModal", "onCancelZoneEdit", "onCancelZoneCreate", "onToggleTagActions"]))
              : _createCommentVNode("", true),
            _createVNode(_component_dropdown_button, {
              icon: ['fas', 'image'],
              name: 'Floorplans',
              "is-dropdown-opened": _ctx.showFloorplansDatagrid,
              onToggleDatagrid: _ctx.toggleFloorplansDatagrid
            }, null, 8, ["is-dropdown-opened", "onToggleDatagrid"]),
            (_ctx.showFloorplansDatagrid)
              ? (_openBlock(), _createBlock(_component_floorplan_map, {
                  key: 2,
                  floorplans: _ctx.floorplans,
                  "get-selected-row": _ctx.getSelectedFloorplanRow,
                  "is-floorplan-create-mode": _ctx.isFloorplanCreateMode,
                  "is-floorplan-edit-mode": _ctx.isFloorplanEditMode,
                  onSaveFloorplan: _ctx.saveFloorplan,
                  onSaveEditFloorplan: _ctx.saveEditFloorplan,
                  onChangeFloorplanToEditMode: _ctx.changeFloorPlanToEditMode,
                  onToggleCreateFloorplanModal: _ctx.toggleCreateFloorPlanModal,
                  onToggleFloorplanDeleteModal: _ctx.toggleFloorplanDeleteModal,
                  onCancelFloorplanEditMode: _ctx.cancelFloorPlanEditMode,
                  onCancelFloorplanCreateMode: _ctx.cancelFloorPlanCreateMode,
                  onToggleTagActions: _ctx.toggleTagActions
                }, null, 8, ["floorplans", "get-selected-row", "is-floorplan-create-mode", "is-floorplan-edit-mode", "onSaveFloorplan", "onSaveEditFloorplan", "onChangeFloorplanToEditMode", "onToggleCreateFloorplanModal", "onToggleFloorplanDeleteModal", "onCancelFloorplanEditMode", "onCancelFloorplanCreateMode", "onToggleTagActions"]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.showTagsDatagrid)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_tags_map, {
                  tags: _ctx.tags,
                  "get-selected-row": _ctx.getSelectedTagRow,
                  "is-tag-create-mode": _ctx.isTagCreateMode,
                  "is-tag-edit-mode": _ctx.isTagEditMode,
                  onSaveTag: _ctx.saveNewTag,
                  onSaveEditTag: _ctx.saveEditTag,
                  onChangeTagToEditMode: _ctx.changeTagToEditMode,
                  onToggleCreateTagModal: _ctx.toggleCreateTagModal,
                  onToggleTagDeleteModal: _ctx.toggleTagDeleteModal,
                  onCancelTagEditMode: _ctx.cancelTagEditMode,
                  onCancelCreating: _ctx.cancelTagCreateMode,
                  onCloseTagActions: _ctx.closeTagActions
                }, null, 8, ["tags", "get-selected-row", "is-tag-create-mode", "is-tag-edit-mode", "onSaveTag", "onSaveEditTag", "onChangeTagToEditMode", "onToggleCreateTagModal", "onToggleTagDeleteModal", "onCancelTagEditMode", "onCancelCreating", "onCloseTagActions"])
              ]))
            : _createCommentVNode("", true),
          _hoisted_7
        ])
      ]),
      _: 1
    })
  ], 64))
}